/**
 * 关于字串的静态方式 (lodash 没有的功能)
 */
class String {
  /**
   * 乱数产生字串
   * @param options.pool 可自定义字母池
   * @param options.length 字串长度
   * @returns {string}
   */
  static random (options) {
    let text = []
    let pool = options.pool || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let length = typeof options === 'number' ? options : (options.length || 20)

    for (let i = 0; i < length; i++) {
      text.push(pool.charAt(Math.floor(Math.random() * pool.length)))
    }

    return text.join('')
  }

  static sort (str, bool) {
    const x = str.split('')
    x.sort()
    return (bool) ? x.join('') : x.reverse().join('')
  }
}

export default String
